// initial state
const state = {}

// getters
const getters = {}

// actions (async and xhrs)
const actions = {
  // getAllProducts ({ commit }) {
  //   shop.getProducts(products => {
  //     commit('setProducts', products)
  //   })
  // }
}

// mutations - Synchronous operations
const mutations = {
  SET_LOGIN_DATA (state, loginData) {
    this.state.login = loginData
    this.state.profile = loginData.loginResponse.profile
    this.state.order = loginData.loginResponse.orderWrapper
  }

  // decrementProductInventory (state, { id }) {
  //   const product = state.all.find(product => product.id === id)
  //   product.inventory--
  // }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
